var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"advertiseList"},_vm._l((_vm.advertiseMentLIst),function(item,index){return _c('div',{key:index,on:{"click":function($event){return _vm.goDatails(item.banner.url)}}},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":item.banner.thumb_url}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }